module.exports = __webpack_public_path__ + "img/logo Klinisia.caaae5ce.svg";